import { useContext, useEffect, useMemo } from "react";
import HomePageContext from "../HomePageContext";
import Message from "../Message/Message";
import "./messages.scss";

const Messages = () => {
  const { messages, sending, getMessages } = useContext(HomePageContext);

  useEffect(() => {
    getMessages();

    const interval = setInterval(() => {
      getMessages();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [getMessages]);

  const filteredMessages = useMemo(() => {
    return messages.filter(
      m => m.message !== "" || (m.files.length !== 0 && m.message === "")
    );
  }, [messages]);

  return (
    <div className="messages">
      {filteredMessages.map(m => (
        <Message message={m} key={m.id} />
      ))}

      {sending && (
        <div className="message">
          <div className="messageContent">
            <div className="mess typing">
              <div className="dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Messages;
